<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-6 col-lg-6">
                        <div class="font-weight-bold body-1">
                            Editar Cliente
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="6" lg="6">
                        <v-form ref="form" @submit.prevent="save">
                            <client-form ref="ClientForm" :values="form" @save="save" :serverErrors="serverErrors" :edit="true"></client-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="6" lg="6" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../helpers/Utils';
import ClientForm from "./Form.vue";
export default {
    components: {
        'client-form': ClientForm,
    },
	data(){
		return {
            slug: this.$route.params.slug,
            loading: false,
            serverErrors: {},
            form: {
                name: "",
                email: "",
                rfc: "",
                origin: "",
                country_code: null,
                contact: "",
                address:"",
                neighborhood:"",
                city:"",
                state:"",
                country:"",
                zip_code:"",
                status: 0,
                interior_number:"",
                exterior_number:"",
                cfdi_use:"",
                fiscal_regime:"",

                aux_file: []
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Clients",
                block:false,	
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar cambios",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        this.index();
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate();
            // return true;
		},
        index()
        {
            this.$store.state.loading = true;
            this.loading = true;
            this.$api.customer.get(this.$store.state.business, this.slug)
                .then((resp) => {

                    this.form = {...resp.data, country_code: {value: resp.data.country_code, text: resp.data.country}};
                    if(resp.data.country_code == 'MX')
                        this.form.country_code.text = "MÉXICO";
                    
                })
                .catch((error) =>{
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.loading = false;
                    this.loading = false;
                })
        },
        save(){
            
            //console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                console.log(JSON.stringify(form))
                this.$api.customer.update(this.$store.state.business ,this.slug, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.$router.push({name: 'Clients'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },

        prepareRequest(request)
        {

            let data = {...request, country_code:request.country_code.value, country:request.country_code.text}
            console.log(data, request);
            delete data.business;
            return data;
        }
    },
}
</script>

<style>

</style>